import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../infrastructure/redux/store';
import { Container, Input, Cor } from './styles';

interface Props {
  id_professor: number;
  onChange: (id_professor: number, id_cor: number) => void;
}

const Cores: React.FC<Props> = (props) => {
  const { theme } = useSelector((state: RootState) => state.theme);

  const cores = [
    { codigo: '1', hex: theme.colors.color1 },
    { codigo: '2', hex: theme.colors.color2 },
    { codigo: '3', hex: theme.colors.color3 },
    { codigo: '4', hex: theme.colors.color4 },
    { codigo: '5', hex: theme.colors.color5 },
    { codigo: '6', hex: theme.colors.color6 },
  ];

  const handle_change = (id_cor: number) => {
    props.onChange(props.id_professor, id_cor);
  };

  return (
    <Container onChange={(e: any) => handle_change(Number(e.target.value))}>
      {cores.map((cor, index) => (
        <Fragment key={index}>
          <Input
            id={`cor-${props.id_professor}-${cor.codigo}`}
            name={`cor-${props.id_professor}`}
            defaultChecked={index === 0}
            value={index + 1}
          />
          <Cor color={cor.hex} htmlFor={`cor-${props.id_professor}-${cor.codigo}`} />
        </Fragment>
      ))}
    </Container>
  );
};

export { Cores };
